<script setup>
import { computed, watch, ref, getCurrentInstance, nextTick } from 'vue';
import ThemesEditorTab from './ThemesEditorTab';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Refs ---

const themesEditorTabs = ref(null);

// --- Computed ---

const activeEditorKey = computed(() => store.state.themes.activeEditorKey);
const editors = computed(() => store.state.themes.editors);

// --- Watchers ---

watch(activeEditorKey, (val) => {
    // Preserving the early return from your original code
    return;

    /* Note: The logic below is currently unreachable due to the return above.
       If enabled, it handles scrolling the active tab into view.
    */
    if (val >= 0) {
        // nextTick() is the modern replacement for short setTimeouts to wait for DOM updates
        setTimeout(() => {
            const tabsBox = themesEditorTabs.value;
            if (!tabsBox) return;

            const container = tabsBox.closest('[data-themes-editor-toolbar]');
            if (!container) return;

            const containerRect = container.getBoundingClientRect();
            const containerLeft = containerRect.left;
            const containerRight = containerRect.right;

            const nodes = tabsBox.querySelectorAll('.themes-editor-tab');
            const els = Array.from(nodes);
            const activeTab = els[val];

            if (!activeTab) return;

            const activeTabRect = activeTab.getBoundingClientRect();
            const activeTabLeft = activeTabRect.left;
            const activeTabRight = activeTabRect.right;

            if (activeTabRight > containerRight) {
                const dist = Math.abs(containerRight - activeTabRight);
                container.scrollLeft += dist;
            } else if (activeTabLeft < containerLeft) {
                const dist = Math.abs(containerLeft - activeTabLeft);
                container.scrollLeft -= dist;
            }
        }, 50);
    }
});
</script>

<template>
    <div ref="themesEditorTabs" class="d-flex align-items-center py-1">
        <ThemesEditorTab v-for="(editor, index) in editors" :key="index" :editor="editor" :index="index"/>
    </div>
</template>